module.exports = __webpack_public_path__ + "img/logo.52362f2d.png";